export default __webpack_public_path__ + "static/media/gallery-wip-grenade cap_00.7c44b2da.jpg";